import { SET_TOKEN } from '../actions/token';
export default function lang(state = {}, action) {
    switch (action.type) {
    case SET_TOKEN:
        return action.value;
    default:
        return state
    }
}